module.exports = __webpack_public_path__ + "static/media/helper.99879c3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/helper.jpg
// module id = 199
// module chunks = 0